/* unplugin-vue-components disabled */import { render } from "./CommentItem.vue?vue&type=template&id=06a6ea93&scoped=true&ts=true"
import script from "./CommentItem.vue?vue&type=script&lang=ts"
export * from "./CommentItem.vue?vue&type=script&lang=ts"

import "./CommentItem.vue?vue&type=style&index=0&id=06a6ea93&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a6ea93"],['__file',"src/components/list-detail/Comment/CommentItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06a6ea93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06a6ea93', __exports__)) {
    console.log('reload')
    api.reload('06a6ea93', __exports__)
  }
  
  module.hot.accept("./CommentItem.vue?vue&type=template&id=06a6ea93&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('06a6ea93', render)
  })

}


export default __exports__